<template>
  <v-layout wrap fill-height>
      <div class="column">
        <div class="predefined-careboxes">
          <h2>Care Boxes</h2>
          <div v-for="product in products.careboxes" :key="product.id" class="carebox" :class="['product',{ 'highlighted': isHighlighted(product) }]"
               @click="addCarebox(product)">
            <p class="margin-custom"><b>{{ product.name }}</b></p>
            <p class="margin-custom"><b>Price: </b>€{{ product.price }}</p>
          </div>
          <div v-for="product in products.individualBoxes" :key="product.id" class="carebox" :class="['product',{ 'highlighted': isHighlighted(product) }]">
            <p class="margin-custom"><b>{{ product.name }}</b></p>
            <p class="margin-custom">&nbsp;</p>
          </div>
        </div>
        <div class="care-products">
          <h2>Available Products</h2>
          <div v-for="product in products.products" :key="product.id" class="product" :class="['product', { 'disabled': isDisabled(product) }]" @click="addProduct(product, false)">
            <p class="margin-custom"><b>{{ product.name }}</b></p>
            <p class="margin-custom">{{ product.description }}</p>
            <p class="margin-custom"><b>Price: </b>€{{ product.price }}</p>

          </div>
        </div>

      </div>
      <div class="column">
        <h2>Selected Products</h2>
        <div class="banner" :class="[{ 'banner-show': minMarginReached  || orderProducts}, {'banner-danger': !minMarginReached && orderProducts}]">
          <p :class="{ 'show': minMarginReached && !orderProducts}">Minimum margin achieved!</p>
          <p :class="{ 'show': minMarginReached && orderProducts}">Minimum Order value achieved. Order can be placed!</p>
          <p :class="{ 'show': !minMarginReached && orderProducts}">Order cannot be placed!</p>
        </div>
        <div class="price">
          <p>Total Price: €{{ totalPrice.toFixed(2) }}</p>
        </div>
        <div v-for="selectedProduct in selectedProducts" :key="selectedProduct.product.id" class="product selected-product">
          <button class='btn-remove' @click="removeProduct(selectedProduct.product)">Remove</button>
          <p class="margin-custom"><b>{{ selectedProduct.product.name }}</b></p>
          <p class="margin-custom">{{ selectedProduct.product.description }}</p>
          <p class="margin-custom"><b>Quantity : </b> {{ selectedProduct.quantity }}</p>
        </div>

      </div>
  </v-layout>
</template>


<style>
.column {
  flex: 1;
  padding: 20px;
}
.product {
  cursor: pointer;
  margin-bottom: 10px;
  padding: 10px;
  border: 1px solid #d7d5d5;
  border-radius: 10px;
  box-shadow: 0px 0px 5px 1px #d7d5d5;
}
.carebox {
  width: 150px;
  cursor: pointer;
  margin-right: 10px;
  margin-bottom: 10px;
  padding: 10px;
  border: 1px solid #d7d5d5;
  border-radius: 10px;
  box-shadow: 0px 0px 5px 1px #d7d5d5;
  display: inline-block;

}
.selected-product {
  background-color: rgba(76, 175, 80, 0.10);
  border-color: #4CAF50;
}
.disabled {
  background-color: #ddd;
  pointer-events: none;
  opacity:0.5;
}
.banner {
  height:40px;
  background-color: #4CAF50;
  color: white;
  padding: 10px;
  text-align: center;
  margin-bottom: 20px;
  opacity: 0;
  transition: opacity 0.5s;
}
.banner-danger {
  background-color: #da1e1e;
  color: white;
  padding: 10px;
  text-align: center;
  margin-bottom: 20px;
  opacity: 0;
  transition: opacity 0.5s;
}
.banner.banner-show{
  opacity: 1;
}
.banner p{
  display:none;
  margin-bottom:0px;
}
.banner p.show {
  display: block;
}
.highlighted {
  border-color: #4CAF50;
  background-color: #e0f7fa;
}
.btn-remove
{
  background-color: rgba(255, 255, 255, 0.75);
  color: red;
  border-color: red;
  border-style: solid;
  border-radius: 20px;
  padding: 5px 10px;
  font-weight: 400;
  float: right;
}
.margin-custom
{
  margin: 0px 0px 5px 0px;
}
.care-products
{
  margin-top:25px;
}
.price
{
  text-align:right;
  font-size: 20px;
  font-weight: bold;
}
</style>

<script>

export default {
  name: 'CareboxCalculator',

  data: function() {
    return {
      products: [],
      selectedProducts: [],
      minProfitMargin: 5.96,
      maxTotalPrice: 42,
      currentlySelectedCarebox: null
    };
  },
  computed: {
    totalProfitMargin() {
      return this.selectedProducts.reduce((sum, selectedProduct) => sum + selectedProduct.product.margin * selectedProduct.quantity, 0);
    },
    totalPrice() {
      return this.selectedProducts.reduce((sum, selectedProduct) => sum + selectedProduct.product.price * selectedProduct.quantity, 0);
    },
    canOrder() {
      return this.totalProfitMargin >= this.minProfitMargin && this.totalPrice <= this.maxTotalPrice;
    },
    minMarginReached() {
      return this.totalProfitMargin >= this.minProfitMargin;
    },
    orderProducts() {
      return this.maxTotalPrice*.8 <= this.totalPrice
    }
  },
  methods: {
    fetchProducts() {
      this.products = {
        "careboxes": [
          {
            "name": "Carebox 1",
            "product_ids": [1, 4, 7, 10],
            "margin": 12.83,
            "price": 35.64,
          },
          {
            "name": "Carebox 2",
            "product_ids": [1, 5, 7, 11],
            "margin": 10.25,
            "price": 36.89,
          },
          {
            "name": "Carebox 3",
            "product_ids": [1, 4, 10, 10],
            "margin": 15.32,
            "price": 38.32,
          },
          {
            "name": "Carebox 4",
            "product_ids": [1, 5, 7, 15],
            "margin": 10.36,
            "price": 35.70,
          },
          {
            "name": "Carebox 5",
            "product_ids": [2, 7, 17],
            "margin": 17.33,
            "price": 37.25,
          },
          {
            "name": "Carebox 6",
            "product_ids": [1, 5, 11, 15],
            "margin": 10.27,
            "price": 34.51,
          }
        ],
        "individualBoxes": [
          {
            "name": "Individuell",
          },
        ],
        "products": [
          {
            "id":1,
            "name": "Händedesinfektion Liquid - TetraMAN B 500ml",
            "description": "",
            "margin":3.46,
            "price": 7.14
          },
          {
            "id": 2,
            "name": "Händedesinfektion Liquid - TetraMAN B 150ml",
            "description": "",
            "margin": 0.19,
            "price": 2.14
          },
          {
            "id":3,
            "name": "Händedesinfektionstücher - Hospisept 100stk.",
            "description": "",
            "margin":1.42,
            "price": 11.90
          },
          {
            "id":4,
            "name": "Flächendesinfektion Liquid - HM Bacillol AF 500 ml",
            "description": "",
            "margin":2.89,
            "price": 6.78
          },
          {
            "id":5,
            "name": "Flächendesinfektionstücher - DecaWIPES BOX N 100 Stk *",
            "description": "",
            "margin":8.01,
            "price": 11.90
          },
          {
            "id":6,
            "name": "Flächendesinfektionstücher - DecaWIPES FLOW N 80Stk",
            "description": "",
            "margin":3.58,
            "price": 9.52
          },
          {
            "id":7,
            "name": "Einmalhandschuhe - Kolibri Premium Vinyl 100 Stkf *",
            "description": "ür einfache Reinigungsarbeiten",
            "margin":7.15,
            "price": 9.52
          },
          {
            "id":8,
            "name": "Einmalhandschuhe - Kolibri Sensitive Nitril 100 Stk *",
            "description": "bei Lebensmittelverarbeitung",
            "margin":6.79,
            "price": 9.52
          },
          {
            "id":9,
            "name": "Einmalhandschuhe - Kolibri Sensitive Latex 100 Stk",
            "description": "bei Lebensmittelverarbeitung",
            "margin":5.06,
            "price": 9.52
          },
          {
            "id":10,
            "name": "Bettschutzeinlagen einmalgebrauch - Kolibri combed PREMIUM classic 25 Stk. (1100 ml / 60*90 cm)",
            "description": "",
            "margin":6.87,
            "price": 12.20
          },
          {
            "id":11,
            "name": "Mundschutz - Kolibri comface Mundschutz 3lg blau m. Elastikbändern 50Stk",
            "description": "",
            "margin": 6.07,
            "price": 8.33
          },
          {
            "id":12,
            "name": "Mundschutz Partikelmaske FFP2 weiß 10Stk",
            "description": "",
            "margin": 5.74,
            "price": 7.74
          },
          {
            "id":13,
            "name": "Schutzschürzen einmalgebrauch  - Schürze 125x75cm weiß 100 Satk kurz *",
            "description": "",
            "margin":9.29,
            "price": 14.28
          },
          {
            "id":14,
            "name": "Schutzschürzen einmalgebrauch  - Schürze 140x80cm weiß 100 Stk lang",
            "description": "",
            "margin":8.57,
            "price": 14.28
          },
          {
            "id":15,
            "name": "Schutzservietten einmalgebrauch  - Schutzservietten 50 Stk.",
            "description": "",
            "margin":4.75,
            "price": 7.14
          },
          {
            "id":16,
            "name": "Schutzservietten einmalgebrauch  - Schutzservietten 100 Stk. (2 Pkg. a 50 Stk.)",
            "description": "",
            "margin":9.50,
            "price": 14.28
          },
          {
            "id":17,
            "name": "Schutzschürzen wiederverwendbar - Gummi-Schürze 90x120cm 500my 1 Stk",
            "description": "",
            "margin":9.29,
            "price": 25.59
          },
          {
            "id":18,
            "name": "Fingerlinge - Med Comfort Fingerlinge Gr.2-5",
            "description": "",
            "margin":4.95,
            "price": 5.95
          }
        ]
      }
      ;
    },
    addCarebox(carebox) {
      this.selectedProducts = [];
      this.currentlySelectedCarebox = carebox;
      carebox.product_ids.forEach((productId) => {
        this.products.products.forEach((product) => {
          if (productId === product.id) {
            this.addProduct(product, true);
          }
        });
      });
    },
    addProduct(product, addedCarebox) {
      this.currentlySelectedCarebox = addedCarebox?this.currentlySelectedCarebox:this.products.individualBoxes[0];
      const selectedProduct = this.selectedProducts.find(p => p.product.id === product.id);
      if (selectedProduct) {
        if((this.totalPrice+selectedProduct.product.price) >= this.maxTotalPrice)
        {
          return;
        }
        selectedProduct.quantity += 1;
      }
      else {
        this.selectedProducts.push({ product: product, quantity: 1 });
      }
    },
    removeProduct(product) {

      const selectedProduct = this.selectedProducts.find(p => p.product.id === product.id);
      if (selectedProduct.quantity > 1) {
        selectedProduct.quantity -= 1;
      } else {
        this.selectedProducts = this.selectedProducts.filter(p => p.product.id !== product.id);
      }
      this.currentlySelectedCarebox = this.selectedProducts.length > 0 ? this.products.individualBoxes[0]: null;
    },
    isDisabled(product) {
      return (this.totalPrice + product.price) > this.maxTotalPrice;
    },
    isHighlighted(product) {
      return this.currentlySelectedCarebox && this.currentlySelectedCarebox.name === product.name;
    },
  },
  mounted() {
    this.fetchProducts();
  }
}
</script>
